export enum Shadow {
	ExtraSmall = `0px 4px 8px 0px rgba(44, 4, 78, 0.21)`,
	Small = '0px 9px 14px 0px rgba(63, 87, 109, 0.05)',
	Medium = '0px 4px 14px 0px rgba(63, 87, 109, 0.1)',
	Large = '0px 4px 34px 0px rgba(63, 87, 109, 0.24)',
	ExtraLarge = '0px 4px 94px 0px rgba(63, 87, 109, 0.14);',
}
